import * as React from 'react';
import {Helmet} from 'react-helmet';
import {WithI18nProps, withI18n} from '@shopify/react-i18n';
import {TextContainer, DisplayText, Link} from '@shopify/polaris';
import {AppLayout, PostAJobCta} from '../../components';
import {Routes} from 'sections/services-marketplace/experts/utilities';
import i18nArgs from './locales';

import styles from './NotFound.scss';

import NotFoundSvg from './notfound.svg';

interface OwnProps {}

type CombinedProps = OwnProps & WithI18nProps;

function NotFound({i18n}: CombinedProps) {
  const actionLinkMarkup = (
    <Link url={Routes.homePath()}>
      {i18n.translate('NotFound.Page.actionLink')}
    </Link>
  );

  return (
    <>
      <Helmet>
        <title>{i18n.translate('NotFound.Meta.title')}</title>
      </Helmet>
      <AppLayout>
        <AppLayout.Container>
          <AppLayout.Section fill>
            <div className={styles.Container}>
              <div className={styles.Message}>
                <TextContainer>
                  <DisplayText size="large" element="h1">
                    {i18n.translate('NotFound.Page.title')}
                  </DisplayText>
                  <DisplayText size="small" element="p">
                    {i18n.translate('NotFound.Page.action', {
                      link: actionLinkMarkup,
                    })}
                  </DisplayText>
                </TextContainer>
              </div>
              <img src={NotFoundSvg} alt="" className={styles.Image} />
            </div>
          </AppLayout.Section>
        </AppLayout.Container>
      </AppLayout>
      <PostAJobCta />
    </>
  );
}

export default withI18n(i18nArgs)(NotFound);
